module.exports = __webpack_public_path__ + "img/1-main.8706c218.jpg";